export const EVENTS = {
    INPUT: 'input',
};

export const TEXTAREA = {
    SELECTOR: 'textarea',
    DEFAULT_LINE_HEIGHT: 20,
    MAX_VISIBLE_ROWS: 10,
    INITIAL_ROWS: 1,
    DEFAULT_ROWS_COUNT: 3,
};

export const OVERFLOW = {
    HIDDEN: 'hidden',
    AUTO: 'auto',
};

export const PROPS = {
    VALUE: 'value',
};
